/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
// Imports for external libraries go here.
import { FC, useEffect, useRef } from 'react';
import { Config, EditableComponent, MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { Footer } from '@marriott/mi-common-static-components';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { ConnectContainerProps } from './ConnectContainer.types';
import { StyledConnectContainer } from './ConnectContainer.styles';
import { experienceFragmentComponentTypes } from '../../modules/utils/constants/constants';
import { sanitize, sanitizePureHTML } from '../../modules/utils/common';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

// Use named rather than default exports.
export const ConnectContainer: FC<ConnectContainerProps> = (pageProps: ConnectContainerProps) => {
  const contentContainerRef = useRef(null);

  const getExperienceFragmentComponent = (type: string, componentProps: any) => {
    let experienceFragmentComponent = null;
    switch (type) {
      case experienceFragmentComponentTypes.universalFooter:
        experienceFragmentComponent = <Footer {...componentProps} />;
        break;

      case experienceFragmentComponentTypes.responsive:
        break;
    }

    return experienceFragmentComponent;
  };

  const getComponent = () => {
    const itemsOrder = pageProps?.cqItemsOrder;
    const cardItems: Record<string, any> = pageProps?.cqItems ?? [];
    const component = [];

    if (itemsOrder && itemsOrder?.length && cardItems) {
      for (const itemKey of itemsOrder) {
        if (cardItems[itemKey] && cardItems[itemKey]?.[':type']) {
          component.push(
            <div key={itemKey}>
              {getExperienceFragmentComponent(cardItems[itemKey]?.[':type'], { model: cardItems[itemKey] })}
            </div>
          );
        }
      }
    }
    return component;
  };

  useEffect(() => {
    if (contentContainerRef && contentContainerRef?.current) {
      const propertyDetails = (contentContainerRef?.current as Element)?.querySelector('.chinese-separator');
      if (propertyDetails && propertyDetails?.parentElement) {
        propertyDetails?.parentElement?.remove();
      }
    }
  }, []);

  //Method for returning Responsive Grid for showing parsys in Author mode
  const ConnectContainer = () => {
    const referencePathText =
      pageProps && pageProps?.referencePath ? sanitize(pageProps?.referencePath?.toString()) : '';

    return pageProps?.referencePath ? (
      <div data-testid="connect-container" data-component-name="o-ppv5-staticwrapper" className="m-container-fullbleed">
        <StyledConnectContainer>
          <section
            dangerouslySetInnerHTML={{ __html: referencePathText }}
            ref={contentContainerRef}
            className="authorBorder"
          />
        </StyledConnectContainer>
      </div>
    ) : (
      <>{getComponent()}</>
    );
  };

  //Method for returning components to be rendering at end point URL
  const ConnectContainerStaticWrapper = (props: ConnectContainerProps) => {
    const { referencePath = '' } = props;
    const referencePathText =
      props?.contentID === 'local-offers'
        ? sanitizePureHTML(referencePath?.toString() ?? '')
        : sanitize(referencePath?.toString() ?? '');

    return referencePath ? (
      <StyledConnectContainer id={pageProps?.contentID}>
        <section dangerouslySetInnerHTML={{ __html: referencePathText }} ref={contentContainerRef} />
      </StyledConnectContainer>
    ) : (
      <>{getComponent()}</>
    );
  };

  const showConnectContainer =
    pageProps.isAuthorMode && pageProps?.isInEditor ? (
      <div>{ConnectContainer()}</div>
    ) : (
      <div>{<ConnectContainerStaticWrapper {...pageProps} />}</div>
    );

  return <StyledConnectContainer className="m-container-fullbleed">{showConnectContainer}</StyledConnectContainer>;
};

export const ConnectContainerConfig = {
  emptyLabel: 'ConnectContainer',
  isEmpty: (_props: MappedComponentProperties) => false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/common/staticwrapper`,
} as Config<MappedComponentProperties>;

export const ConnectContainerEditable = (props: ConnectContainerProps) => (
  <EditableComponent config={ConnectContainerConfig} {...props}>
    <ConnectContainer {...props} />
  </EditableComponent>
);
